import React from "react";

const AnalyzingSpinner = ({ progress = 0, size = 120, stroke = 10, showPercent = true }) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - Math.max(0, Math.min(100, progress)) / 100);

  const containerStyle = {
    width: size,
    height: size,
    margin: "0 auto",
    position: "relative",
  };

  // avoid rotating the whole SVG (creates stacking context that can hide overlayed text)
  const svgStyle = {};

  const centerTextStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: Math.max(16, Math.floor(size / 6)),
    fontWeight: 700,
    color: "#00BFFF",
    pointerEvents: "none",
    zIndex: 9999,
  };

  return (
    <div style={containerStyle} aria-hidden>
      <svg width={size} height={size} style={svgStyle}>
        <defs>
          <linearGradient id="analyzeGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#00BFFF" />
            <stop offset="100%" stopColor="#2DD4BF" />
          </linearGradient>
        </defs>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e6e6e6"
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="url(#analyzeGrad)"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
          fill="none"
          style={{ transition: "stroke-dashoffset 600ms ease, stroke 300ms", transform: `rotate(-90deg)`, transformOrigin: '50% 50%' }}
        />
      </svg>

      {showPercent && (
        <div style={centerTextStyle}>{Math.round(progress)}%</div>
      )}
    </div>
  );
};

export default AnalyzingSpinner;
